import React from 'react'
import { SizingSpacingSystemProps } from '@moonpig/launchpad-system'
import {
  EnvelopeContainer,
  EnvelopeProviderContainer,
  StyledGreetzEnvelope,
  StyledMoonpigEnvelope,
} from './Envelope.styles'
import {
  DefaultEmailProvider,
  GmailEmailProvider,
  OutlookEmailProvider,
} from './EmailProviders'

export type EnvolopeProps = {
  brand: 'moonpig' | 'greetz'
  email?: string
  animationPaused?: boolean
} & SizingSpacingSystemProps

const BrandedEnvelope: React.FC<Pick<EnvolopeProps, 'brand'>> = props => {
  switch (props.brand) {
    case 'greetz':
      return <StyledGreetzEnvelope data-testid="env-greetz" />
    case 'moonpig':
    default:
      return <StyledMoonpigEnvelope data-testid="env-moonpig" />
  }
}

const EmailProviderIcon: React.FC<
  Pick<EnvolopeProps, 'email'> & { defaultFill: string }
> = props => {
  const domain = props.email?.substring(props.email.lastIndexOf('@') + 1)

  switch (domain?.toLowerCase()) {
    case 'gmail.com':
    case 'googlemail.com':
      return <GmailEmailProvider data-testid="env-gmail" />
    case 'msn.com':
    case 'live.com':
    case 'live.co.uk':
    case 'hotmail.com':
    case 'hotmail.co.uk':
    case 'outlook.com':
    case 'outlook.co.uk':
      return <OutlookEmailProvider data-testid="env-outlook" />
    default:
      return (
        <DefaultEmailProvider
          data-testid="env-default"
          fill={props.defaultFill}
        />
      )
  }
}

export const Envelope: React.FC<EnvolopeProps> = ({
  brand,
  email,
  animationPaused = false,
  ...props
}) => {
  const DefaultFillColor = () => {
    return brand === 'moonpig' ? '#34519F' : '#47093A'
  }

  const ContainerStyles = {
    animationPlayState: animationPaused ? 'paused' : 'running',
  }

  return (
    <EnvelopeContainer {...props} style={ContainerStyles}>
      <BrandedEnvelope brand={brand} />
      <EnvelopeProviderContainer>
        <EmailProviderIcon email={email} defaultFill={DefaultFillColor()} />
      </EnvelopeProviderContainer>
    </EnvelopeContainer>
  )
}
